// DS: i3.31
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Copy: React.FC<Props> = props => {
  return (
    <IconWrap {...props} disableDefaultColors>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          d="M21 15.998a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1l9.001.001.1.006a1 1 0 0 1 .626.327l3.019 3.382A1 1 0 0 1 21 7.38zm-6-11H9v10h10v-6h-3a1 1 0 0 1-1-1zm-11 2h2v2H5v10h10v-1h2v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1"
          clipRule="evenodd"
        ></path>
      </svg>
    </IconWrap>
  );
};

Copy.displayName = 'Copy';

export default Copy;
